import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useQuery } from '@tanstack/react-query';

import { whatsAppService } from '../../application/WhatsAppService';
import useErrorMiddleware from '../errorMiddleware/useErrorMiddleware';
import { useShowSnackbarMessage } from '../snackbarMessage/useShowSnackbarMessage';

interface UseRetrieveMetaPhoneProps {
  phone_id: string;
  code?: string;
  auth_token?: string;
  redirect_uri: string;
}

type UseRetrieveMetaPhoneResponse = ServiceResponse<Function, string>;

// Hooks act as 'Adapter' layer.
export const useRetrieveMetaPhone = ({
  phone_id,
  code,
  auth_token,
  redirect_uri,
}: UseRetrieveMetaPhoneProps): UseRetrieveMetaPhoneResponse => {
  const { sessionExpiredLogout } = useErrorMiddleware();
  const { showSnackbarMessage } = useShowSnackbarMessage();

  const { data, isLoading, isSuccess, isError, refetch } = useQuery(
    [`retrieveMetaPhone`, phone_id, code],
    (): Promise<string> => {
      return whatsAppService.retrieveMetaPhone({
        phone_id,
        code,
        auth_token,
        redirect_uri,
      });
    },
    {
      enabled: false,
      onSuccess: () => {
        console.log(`Meta phone retrieved successfully`);
      },
      onError: (err: any) => {
        console.info(`Retrieve phone error:`, err);
        if (err?.response?.status === 401) {
          sessionExpiredLogout();
          return;
        }
        showSnackbarMessage({
          messageIntlId: `infoerror.${err?.response?.data?.messageId ?? `network_error`}`,
        });
      },
    }
  );

  return {
    run: refetch,
    data,
    error: isError,
    success: isSuccess,
    isLoading: isLoading,
  };
};
